import { appInfo } from '@/mocks/homeMocks';

export default function AppSection() {
  return (
    <section id="app" className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3 scroll-mt-20">
                {appInfo.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6 max-w-lg">
                {appInfo.description}
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-6">
                {appInfo.features.map((feature) => (
                  <span
                    key={feature}
                    className="flex items-center gap-1.5 px-3 py-1.5 bg-background-50 rounded-full text-xs text-foreground-700 border border-background-200/70 whitespace-nowrap"
                  >
                    <i className="ri-check-line text-primary-500 text-xs"></i>
                    {feature}
                  </span>
                ))}
              </div>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#app"
                  className="px-6 py-2.5 bg-foreground-950 text-background-50 rounded-lg text-sm whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors inline-flex items-center gap-2"
                >
                  <i className="ri-apple-fill"></i> App Store
                </a>
                <a
                  href="#app"
                  className="px-6 py-2.5 bg-primary-500 text-white rounded-lg text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors inline-flex items-center gap-2"
                >
                  <i className="ri-android-fill"></i> Android 下载
                </a>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="w-48 h-48 md:w-56 md:h-56 bg-background-50 rounded-lg p-4 border border-background-200/70">
                <img
                  src={appInfo.qrImage}
                  alt="虫虫漫画 App 下载二维码"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}